module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("j8gd5"))).then(() => parcelRequire('cvs7o'));